import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Guest Screens
import LoginPage from "./Components/LoginPage/LoginPage";
import GenerateOtp from "./Components/GenerateOtp/GenerateOtp";
import SignUp from "./Components/SignUp/SignUp";

// Layout
import MainScreen from "./Components/MainScreen";

// Guards
import ProtectedRoute from "./routes/ProtectedRoute";
import AclGuard from "./acl/AclGuard";
import GuestRoute from "./routes/GuestRoute";
import { useLocation } from "react-router-dom";


// API Interceptor
import { createAxiosResponseInterceptor } from './api/interceptor';

// Components
import Sidebar from './Components/Drawer/Sidebar';
import BlockTableList from './Components/MainScreens/BlockList/BlockTableList';
import CustomerList from './Components/MainScreens/Customer/CustomerList';
import InactiveCustomer from "./Components/MainScreens/Customer/InactiveCustomer";
import Content from './Components/MainScreens/Content/Content';
import OldGifts from './Components/MainScreens/Gifts/OldGifts';
import NewGifts from './Components/MainScreens/Gifts/NewGifts';
import KycList from './Components/MainScreens/KycList/KycLIst';
import OfflineTransaction from './Components/MainScreens/OfflineTransaction/OfflineTransaction';
import BullionDeposit from './Components/MainScreens/DepositPlan/BullionDeposit';
import SubscriberList from './Components/MainScreens/DepositPlan/SubscriberList';
import Settings from './Components/Settings/Settings';
import RedeemOrder from './Components/MainScreens/RedeemOrder/RedeemOrder';
import Products from './Components/MainScreens/Product/Products';
import CreateAdmin from "./Components/MainScreens/Admin/CreateAdmin";
import AdminList from "./Components/MainScreens/Admin/AdminList";
import Dropdownlist from "./Components/MainScreens/Admin/Dropdownlist";
import CreateStoreList from "./Components/MainScreens/CreateStore/CreateStoreList";
import CreateStoreTableList from "./Components/MainScreens/CreateStore/CreateStoreTableList/CreateStoreTableList";
import CreateJwellerList from "./Components/MainScreens/CreateJweller/CreateJwellerList";
import CreateJwellerTable from "./Components/MainScreens/CreateJweller/CreateJwellerTable";
import CreateProduct from "./Components/MainScreens/CreateProduct/CreateProduct";
import ProductList from "./Components/MainScreens/CreateProduct/ProductList";
import Notification from "./Components/MainScreens/Notification/Notification";
import TransactionDetails from "./Components/MainScreens/TransactionDetails/TransactionDetails";
import SipPlan from "./Components/MainScreens/SipPlan/SipPlan";
import SipList from "./Components/MainScreens/SipPlan/SipList/SipList";
import CreateSipPlanTable from "./Components/MainScreens/SipPlan/CreateSipPlanTable";
import SipPlanGroupPlans from "./Components/MainScreens/SipPlan/SipPlanGroupPlans";
import Carousel from "./Components/MainScreens/Carousel/Carousel";
import CarouselManager from "./Components/MainScreens/Carousel/create-carousel/CarouselManager";
import Blocklist from "./Components/MainScreens/BlockList/Blocklist";
import MetalManagement from "./Components/MainScreens/MetalManangement/MetalManagement";
import MetalRateBuySell from "./Components/MainScreens/MetalRateBuySell/MetalRateBuySell";
import Dashboard from "./Components/Dashboard/Dashboard";
import NewDashboard  from "./Components/NewDashboard/NewDashboard";
import SubscriptionPlan, { CreateSubscriptionPlanPage } from "./Components/MainScreens/SubscriptionPlan/SubscriptionPlan";
import Configuration from "./Components/MainScreens/Configuration/Configuration";
import UploadJewellerDocument from "./Components/MainScreens/Configuration/UploadJewellerDocument";
import AppConfig from "./Components/MainScreens/Configuration/AppConfig";
import Offers from "./Components/MainScreens/Offer/Offer";
import Muhurt from "./Components/MainScreens/Muhurt/Muhurt";
import Redeem from "./Components/MainScreens/RedeemSell/Redeem";
import Sell from "./Components/MainScreens/RedeemSell/Sell";
import ProductCategory from "./Components/MainScreens/ProductCategory/ProductCategory";
import PermissionsPage from "./Components/MainScreens/Permissions/PermissionsPage";
import SubscriptionPlans from "./Components/MainScreens/SubscriptionPlan/SubscriptionList";
import ThemeColorEditor from "./Components/MainScreens/AppTheme/app_theme_selection_screen.js";
import SimpleThemeEditor from "./Components/MainScreens/AppTheme/simple_theme_selection_screen.js";
import InvoicePage from "./Components/MainScreens/TransactionDetails/InvoicePage.js"
 import Cashfree from "./Components/MainScreens/Cashfree/Cashfree.js";
import CashfreePaymentStatus from "./Components/MainScreens/Cashfree/CashfreePaymentStatus.js";
import Reports from "./Components/MainScreens/Reports/Reports.js"
import { Countertops } from "@mui/icons-material";
import CouponList from "./Components/MainScreens/Coupon/CouponList.js";
import CreateFollowup from "./Components/MainScreens/Leads/CreateFollowup.js";
import FollowUpListByDate from "./Components/MainScreens/Leads/FollowUpListByDate.js";
import CreateLeads from "./Components/MainScreens/Leads/CreateLeads.js";
import LeadList from "./Components/MainScreens/Leads/LeadList.js";
// import Required from "./Components/MainScreens/Required/Required.js";
// import RequiredCard from "./Components/MainScreens/Required/RequiredCard.js";
// import CreateFollowup from "./Components/MainScreens/Leads/CreateFollowup.js";
import ProductOrder from "./Components/MainScreens/ProductOrder/productOrder.js";
import JewelleryOrder from "./Components/MainScreens/JewelleryOrder/JewelleryOrder.js";
import DiamondPointsOrder from "./Components/MainScreens/RedeemSell/DiamondPointsOrder.js";
import DiamondPointsOrdersTable from "./Components/MainScreens/CustomerDiamondPointOrders/DiamondPointsOrdersTable.js";
import JewellerSubscription from "./Components/MainScreens/SubscriptionPlan/JewellerSubscription.js";
import BirthdayCustomerList from "./Components/NewDashboard/BirthdayCustomerList.js";
import AppThemeHistory from "./Components/MainScreens/AppTheme/appThemeHistory.js";
import CreateNotification from "./Components/Comman/CreateNotification.js";
import MetalRewards from "./Components/MainScreens/MetalRewards/MetalRewards.js";
import UserPointsOrder from "./Components/MainScreens/RedeemSell/UserPointOrder.js";
import ReferralOrdersTable from "./Components/Settings/ReferralOrdersTable.js";
import SipSubscriberList from "./Components/MainScreens/SipPlan/SipSubscriberList.js";
import AllSubscriptionList from "./Components/MainScreens/SubscriptionPlan/AllSubscriptionList.js";
import CustomerInteraction from "./Components/MainScreens/CustomerInteraction/CustomerInteraction.js";
import IntroScreenManager from "./Components/MainScreens/Intro-Screen/intro-screen.js";
import UiArrangementPage from "./Components/MainScreens/UiArrangement/UiArrangementPage.js";
import Advertisement from "./Components/MainScreens/Advertisement/Advertisement.js";
import BulkGifts from "./Components/MainScreens/Gifts/BulkGifts.js";
import BulkDiamondPoints from "./Components/MainScreens/Gifts/BulkDiamondPoints.js";
import BirthdayGift from "./Components/MainScreens/Gifts/BirthdayGift.js";
import RegistrationGift from "./Components/MainScreens/Gifts/RegistrationGift.js";
import ReferralBenefits from "./Components/MainScreens/Referral/ReferralBenefits.js";
import { controlAllFeatureOptions } from "./configs/constants.js";
import AccessControl from "./Components/Comman/AccessControl.js";
import MetalManagementPage from "./Components/MainScreens/MetalManagement/MetalManagementPage.js";
import TransactionsPage from "./Components/MainScreens/Transactions/TransactionsPage.js";
import AppManagementPage from "./Components/MainScreens/AppManagement/AppManagementPage.js";
import ProductsManagementPage from "./Components/MainScreens/ProductsManagement/ProductsManagementPage.js";
import PlanManagementPage from "./Components/MainScreens/PlanManagement/PlanManagementPage.js";
import GiftsPage from "./Components/MainScreens/Gifts/GiftsPage.js";
import CustomersPage from "./Components/MainScreens/Customers/CustomersPage.js";
import AdminPage from "./Components/MainScreens/Admin/AdminPage.js";
import SubscriptionsPage from "./Components/MainScreens/Subscriptions/SubscriptionsPage.js";
import SettingsPage from "./Components/MainScreens/Settings/SettingsPage.js";
import BookingBullion from "./Components/MainScreens/BookingBullion/BookingBullion.js";
import BookingTransaction from "./Components/MainScreens/BookingBullion/BookingTransaction.js";
import BookingBullionPage from "./Components/MainScreens/BookingBullion/BookingBullionPage.js";
import TicketPage from "./Components/Settings/TicketPage.js";
import BookingReport from "./Components/MainScreens/BookingBullion/BookingReport.js";
import Training from "./Components/MainScreens/Training/Training.js";
import DashboardInfo from "./Components/Comman/DashboardInfo/DashboardInfo.js";
import CreateDashboardInfo from "./Components/Comman/DashboardInfo/CreateDashboardInfo.js";
import FollowupAndLeadsPage from "./Components/MainScreens/Leads/FollowupAndLeadsPage.js";
import LuckyDrawPage from "./Components/MainScreens/LuckyDraw/LuckyDrawPage.js";

function App() {
  createAxiosResponseInterceptor();
  const location = useLocation();

  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} />
      <div style={{ height: "100vh", overflowY: "auto" }}>
        <Routes>

          {/* Guest Routes */}
          <Route path="/" element={<GuestRoute><LoginPage /></GuestRoute>} />
          <Route path="/login" element={<GuestRoute><LoginPage /></GuestRoute>} />
          <Route path="/GenerateOtp" element={<GuestRoute><GenerateOtp /></GuestRoute>} />
          <Route path="/SignUp" element={<GuestRoute><SignUp /></GuestRoute>} />
          <Route path="/invoice/:id" element={<InvoicePage />} />

          {/* Protected Layout Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainScreen />
              </ProtectedRoute>
            }
          >
            {/* <Route
              path="dashboard"
              element={
                <AclGuard aclAbilities={{ action: 'manage', subject: 'dashboard' }}>
                  <Dashboard />
                </AclGuard>
              }
            />
            <Route path="Sidebar" element={<Sidebar />} /> */}
            <Route path="dashboard" element={
              <AclGuard aclAbilities={{ action: "manage", subject: "dashboard" }}>
                <NewDashboard  />
              </AclGuard>
            } />
            {/* <Route
              path="dashboard"
              element={
                <AclGuard
                  aclAbilities={{ action: "manage", subject: "dashboard" }}
                >
                  <Dashboard />
                </AclGuard>
              }
            /> */}
            <Route path="CreateAdmin" element={<CreateAdmin />} />
            <Route path="AdminList" element={<AdminList />} />
            <Route path="Dropdownlist" element={<Dropdownlist />} />
            <Route path="CreateStoreList" element={<CreateStoreList />} />
            <Route path="CreateStoreTableList" element={<CreateStoreTableList />} />
            <Route path="Redeem" element={<AccessControl feature={controlAllFeatureOptions.Redeem}><Redeem /></AccessControl>} />
            <Route path="Sell" element={<AccessControl feature={controlAllFeatureOptions.Sell}><Sell /></AccessControl>} />

            <Route
              path="CreateStoreTableList"
              element={<CreateStoreTableList />}
            />
            <Route path="CreateJwellerList" element={<CreateJwellerList />} />
            <Route path="CreateJwellerTable" element={<CreateJwellerTable />} />
            <Route path="CreateProduct" element={<CreateProduct />} />
            <Route path="ProductList" element={<ProductList />} />
            <Route path="productlists" element={<AccessControl feature={controlAllFeatureOptions.Look_Book}><Products /> </AccessControl>} />
            <Route path="productcategory" element={<AccessControl feature={controlAllFeatureOptions.Look_Book}><ProductCategory /></AccessControl>} />
            <Route path="MetalManagement" element={<MetalManagement />} />
            <Route path="MetalRateBuySell" element={<MetalRateBuySell />} />
            <Route path="Notification" element={<Notification />} />
            <Route path="SipPlan" element={<AccessControl feature={controlAllFeatureOptions.Sip}><SipPlan /> </AccessControl>} />
            <Route path="SipList" element={<SipList />} />
            <Route path="CreateSipPlanTable" element={<AccessControl feature={controlAllFeatureOptions.Sip}><CreateSipPlanTable /></AccessControl>} />
            <Route
              path="SipPlanGroup/:parentId"
              element={
                <AccessControl feature={controlAllFeatureOptions.Sip}>
                  <SipPlanGroupPlans />
                </AccessControl>
              }
            />
            <Route path="Carousel" element={<Carousel />} />
            <Route path="CarouselManager" element={<CarouselManager />} />
            <Route path="Reports" element={<Reports/>} />
            <Route path="MetalRewards" element={<MetalRewards />} />

            <Route path="TransactionDetails" element={<TransactionDetails />} />
            <Route path="KycList" element={<KycList />} />
            <Route path="OfflineTransaction" element={<OfflineTransaction />} />
            <Route path="BullionDeposit" element={<BullionDeposit />} />
            <Route path="SubscriberList" element={<AccessControl feature={controlAllFeatureOptions.Look_Book}><SubscriberList /></AccessControl>} />
            <Route path="Settings" element={<Settings />} />
            <Route path="Blocklist" element={<Blocklist />} />
            <Route path="BlockTableList" element={<BlockTableList />} />
            <Route path="AdminList" element={<AdminList />} />
            {/* <Route path="CreateAdminTable" element={<CreateAdminTable />} /> */}
            <Route path="Dropdownlist" element={<Dropdownlist />} />
            <Route path="CreateStoreList" element={<CreateStoreList />} />
            <Route path="CreateStoreTableList" element={<CreateStoreTableList />} />
            <Route path="CreateJwellerList" element={<CreateJwellerList />} />
            <Route path="CreateJwellerTable" element={<CreateJwellerTable />} />
            <Route path="RedeemOrder" element={<RedeemOrder />} />
            <Route path="Configuration" element={<Configuration />} />
            <Route path="UploadJewellerDocument" element={<UploadJewellerDocument />} />
            <Route path="AppConfig" element={<AppConfig />} />
            <Route path="CustomerList" element={<CustomerList />} />
            <Route path="InactiveCustomer" element={<InactiveCustomer />} />
            <Route path="Content" element={<Content />} />
            <Route path="NewGifts" element={<NewGifts />} />
            <Route path="OldGifts" element={<AccessControl feature={controlAllFeatureOptions.Old_Gift}><OldGifts /></AccessControl>} />
            <Route path="Offers" element={<Offers />} />
            <Route path="Muhurt" element={ <AccessControl feature={controlAllFeatureOptions.Muhurat_Calender}><Muhurt /></AccessControl>} />
            <Route path="Redeem" element={<AccessControl feature={controlAllFeatureOptions.Redeem}><Redeem /></AccessControl>} />
            <Route path="Sell" element={<AccessControl feature={controlAllFeatureOptions.Sell}><Sell /></AccessControl>} />
            <Route path="SubscriptionPlan" element={<SubscriptionPlan />} />
            <Route path="JewellerSubscription" element={<JewellerSubscription />} />
            <Route path="Subscription" element={<SubscriptionPlans />} />
            <Route path="Permissions" element={<PermissionsPage />} />
            <Route path="CreateLeads" element={<CreateLeads/>} />
            <Route path="LeadList" element={<LeadList/>} />
            <Route path="/CreateFollowup" element={<CreateFollowup/>} />
        
           <Route path="/cashfree/:sessionId/:orderId" element={<Cashfree  />} />
            <Route path="/cashfree/payment-status/:orderId" element={<CashfreePaymentStatus  />} />
            <Route path="CouponList" element={<CouponList />}></Route>
             <Route path="AppThemeSelector" element={<ThemeColorEditor />} />
             <Route path="SimpleThemeSelector" element={<SimpleThemeEditor />} />
            <Route path="FollowUpListByDate" element={<FollowUpListByDate />} /> 

            <Route path="ProductOrder" element={<ProductOrder />} />
            <Route path="JewelleryOrder" element={<JewelleryOrder />} />
            <Route path="DiamondPointsOrder" element={<AccessControl feature={controlAllFeatureOptions.Diamond_Points}><DiamondPointsOrder /></AccessControl>} />
            <Route path="CustomerDiamondPointsOrder" element={<AccessControl feature={controlAllFeatureOptions.Diamond_Points}><DiamondPointsOrdersTable /></AccessControl>} />
            <Route path="BirthdayCustomerList" element={<BirthdayCustomerList />} />
            <Route path="AppThemeHistory" element={<AppThemeHistory />} />
            <Route path="CreateNotification" element={<CreateNotification />} />
            <Route path="UserPointsOrder" element={<UserPointsOrder />} />
             <Route path="ReferralOrdersTable" element={<ReferralOrdersTable />} />
             <Route path="SipSubscriberList" element={<SipSubscriberList />} />
             <Route path="AllSubscriptionList" element={<AllSubscriptionList />} />
             <Route path="/CustomerInteraction" element={<AccessControl feature={controlAllFeatureOptions.Customer_Interaction}><CustomerInteraction /></AccessControl>} />
             <Route path="/introScreen" element={<AccessControl feature={controlAllFeatureOptions.Intro_Screen}><IntroScreenManager /></AccessControl>} />
             <Route path="/UiArrangement" element={<UiArrangementPage />} />
             <Route path="/Advertisement" element={<Advertisement />} />
             <Route path="/BulkGifts" element={<BulkGifts />} />
             <Route path="/BulkDiamondPoints" element={<BulkDiamondPoints />} />
            <Route path="/BirthdayGift" element={<BirthdayGift />} />
            <Route path="/RegistrationGift" element={<RegistrationGift />} />
            <Route path="/ReferralBenefits" element={<ReferralBenefits />} />
            <Route path="/MetalManagementPage" element={<MetalManagementPage />} />
            <Route path="/TransactionsPage" element={<TransactionsPage />} />
            <Route path="/AppManagementPage" element={<AppManagementPage />} />
            <Route path="/ProductsManagementPage" element={<ProductsManagementPage />} />
            <Route path="/PlanManagementPage" element={<PlanManagementPage />} />
            <Route path="/GiftsPage" element={<GiftsPage />} />
            <Route path="/CustomersPage" element={<CustomersPage />} />
            <Route path="/AdminPage" element={<AdminPage />} />
            <Route path="/SubscriptionsPage" element={<SubscriptionsPage />} />
            <Route path="/CreateSubscriptionPlan" element={<CreateSubscriptionPlanPage />} />
            <Route path="/SettingsPage" element={<SettingsPage />} />
            <Route path="/BookingBullionPage" element={<BookingBullionPage />} />
            <Route path="/BookingBullion" element={<BookingBullion />} />
            <Route path="/BookingTransaction" element={<BookingTransaction />} />
            <Route path="/TicketPage" element={<TicketPage />} />
             <Route path="/BookingReport" element={<BookingReport />} />
              <Route path="/Training" element={<Training />} />
             <Route path="/DashboardInfo" element={<DashboardInfo key={location.state?.key || "default"} />} />
             <Route path ="/createDashboardInfo" element={<CreateDashboardInfo />} />
             <Route path="/FollowupAndLeadsPage" element={<FollowupAndLeadsPage />} />
            <Route path="/LuckyDrawPage" element={<LuckyDrawPage />} />
          </Route>
          <Route path="/invoice/:id" element={ <ProtectedRoute> <InvoicePage /> </ProtectedRoute> }/>
        </Routes>
      </div>
    </>
  );
}

export default App;